import { type VariablesOf } from '@graphql-typed-document-node/core'
import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

const document = graphql(`
  mutation DocumentReportArchiveListPage_UpdateDocumentReportStatus(
    $documentReportId: ID!
    $newStatus: DocumentStatusType!
  ) {
    changeDocumentStatus(documentId: $documentReportId, newStatus: $newStatus) {
      ok
    }
  }
`)
type Variables = VariablesOf<typeof document>

export const useUpdateDocumentReportStatusMutation = (
  options: MutationOptions<void, Variables> = {},
) => {
  const graphQLRequest = useGraphQLRequest()
  const { t } = useTranslation()

  return useMutation({
    mutationFn: async (variables) => {
      const result = await graphQLRequest({ document, variables })
      const ok = result.changeDocumentStatus?.ok ?? false
      if (!ok) {
        throw new Error(t('update_failed'))
      }
    },
    ...options,
  })
}
